import React from 'react';
import ReactModal from 'react-modal'
import { IGroupSubscriptionMembersModalProps } from './IGroupSubscriptionMembersModalProps';
import styles from './GroupSubscriptionMembersModal.module.scss';
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';
import { SearchIcon } from "constants/icons";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { GroupService } from 'api/services/groups';
import { AddUsersToContentPopUpLoader } from 'containers/CoursesContainer/Drip/SectionDripSettings/AccessTablePopup/AccessTablePopup';
import GroupSubscriptionMember from './GroupSubscriptionMember/GroupSubscriptionMember';
import DeleteConfirmation from 'containers/channels/collections/deleteConfirmation';
import { ReactComponent as OwnerBadgeIcon } from './GroupSubscriptionMember/icons/badge.svg';
import AppToolTip from 'elements/tooltip/AppToolTip';

const GroupSubscriptionMembersModal: React.FC<IGroupSubscriptionMembersModalProps> = (props: any) => {

    const [searchString, setSearchString] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(true);
    const [members, setMembers] = React.useState<any>(() => {
        if(props.parentAccountData) {
            return [props.parentAccountData];
        }

        return null;
    });
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = React.useState<boolean>(false);

    const deletingMemberRef = React.useRef<any>(null);

    React.useEffect(() => {
        if(!props.isOpen && members) {
            setMembers(null);
        } 
        if(
            props.group &&
            props.isOpen && 
            !members
        ) {
            getGroupSubscriptionMembers();
        }

        if(
            !props.isOpen &&
            searchString
        ) {
            setSearchString("");
        }
    }, [props.isOpen]);

    React.useEffect(() => {
        if(props.isOpen && searchString.trim() === '') {
            getGroupSubscriptionMembers();
        }
    }, [searchString]);

    const getGroupSubscriptionMembers = () => {
        let query = "";

        if(searchString.length) {
            query = `?search=${searchString}`
        }

        setLoading(true);
        GroupService.getInstance()
        .getMembershipSubscriptionSubAccounts(
            props.group && props.group.id,
            props.group && props.group.user_membership && props.group.user_membership.id,
            query
        )
        .then((response: any) => {
            const nextMembers = props.parentAccountData && query.length === 0 ? [
                props.parentAccountData,
                ...response.data,
            ] : response.data;
            setLoading(false);
            setMembers(nextMembers);
        })
        .catch(() => {
            setLoading(false);
        });
    }

    const requestDeleteMember = (userMembership: any) => {
        deletingMemberRef.current = userMembership;
        setIsDeleteConfirmationOpen(true);
    }

    const removeMember = () => {
        setIsDeleteConfirmationOpen(false);
        removeGroupSubscriptionMember(deletingMemberRef.current);
    }

    const removeGroupSubscriptionMember = (userMembership: any) => {
        GroupService.getInstance()
        .removeMembershipSubscriptionSubAccount(
             props.group && props.group.id,
            props.group && props.group.user_membership && props.group.user_membership.id,
            userMembership && userMembership.id
        )
        .then(() => {
            if(props.refetchGroupData) {
                props.refetchGroupData();
            }
            setMembers(members.filter((member: any) => member.id !== userMembership.id))
        })
        .catch(() => {})
    }

  return (
    <>
    <ReactModal
        isOpen={props.isOpen}
        className={styles.modal_container}
        style={{
            content: {
                maxHeight: "85vh", // Keeps it from covering the full height
                margin: "auto",
                overflow: "hidden", // Ensures only the inner content scrolls
            },
            overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 2147483647,
            }
        }}
    >
            <div 
            className={styles.header_container}
            >
                <h1
                className={styles.header_title}
                >
                    Members
                </h1>
                <span
                    onClick={() => props.onClose()}
                    className={styles.header_icon_container}
                >
                    <CloseIcon />
                </span>
            </div>

            <div 
            className={styles.header_actions_container}
            >
                <div 
                className={styles.header_actions_search_container}
                >
                    <input
                    placeholder="Search for subscription members"
                    value={searchString}
                    onChange={e => setSearchString(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            getGroupSubscriptionMembers();
                        }
                    }}
                    className={styles.header_actions_search_input}
                    />
                    <span
                    onClick={() => {
                        getGroupSubscriptionMembers();
                    }}
                    className={styles.header_actions_search_icon_container}
                    >
                        <SearchIcon />
                    </span>
                </div>
                {/* <div
                className={styles.header_actions_submit_container}
                >
                    <button
                    onClick={() => {}}
                    >
                    
                    </button>
                </div> */}
            </div>

                   {/* table section */}
            <PerfectScrollbar
                style={{
                    maxHeight: "55vh", // Ensures it does not take up too much space
                    overflowY: "auto", // Enables scrolling
                    minHeight: "50vh"
                }}
                className={styles.list_container}
                id='add-users-to-content-list'
                options={{
                    wheelPropagation: false,
                }}
            >
                {loading ? (
                    <div className={styles.fallback_container}>
                        <div
                        className={styles.fallback_wrapper}
                        >
                            {
                            Array(12).fill('').map((_e, i) => (
                                <AddUsersToContentPopUpLoader key={i} />
                            ))
                            }
                        </div>
                    </div>
                ) : (<></>)}

                {!loading && members && members.length ? 
                    <div
                    className={styles.list_wrapper}
                    >
                        { members.map((member: any, index: number) => (
                        <GroupSubscriptionMember
                        key={`${index}`}
                        subscriptionMember={member}
                        group={props.group}
                        removeMember={requestDeleteMember}
                        rowClassName={styles.list_item_container}
                        hideRemoveMemberOption={
                            props.parentAccountData &&
                            member &&
                            member.id === props.parentAccountData.id
                        }
                        badge={
                            props.parentAccountData &&
                            member &&
                            member.id === props.parentAccountData.id ?
                            <AppToolTip
                            content="Subscription owner"
                            zIndex={2147483647}
                            >
                                <span
                                className={styles.badge_container}
                                >
                                    <OwnerBadgeIcon
                                    />
                                </span>
                            </AppToolTip> : <></>
                        }
                        />
                        ))}
                    </div> : <></>
                }

                {!loading && members && !members.length && !searchString ? (
                    <div
                    className={styles.fallback_wrapper}
                    >
                        <div
                        className={styles.fallback_empty_container}
                        >
                            <h3
                            className={styles.fallback_empty_title}
                            >No members yet</h3>
                            <p
                            className={styles.fallback_empty_subtext}
                            >
                                Invite members to join group subscription
                            </p>
                            {!props.hideInviteButton && props.onInvite ? (
                                <button
                                className={styles.fallback_action}
                                onClick={() => props.onInvite()}
                                >
                                    Invite Members
                                </button>
                            ) : <></>}
                        </div>
                    </div>
                ) : <></>}

                {!loading && members && !members.length && searchString ? (
                    <div
                    className={styles.fallback_wrapper}
                    >
                        <div
                        className={styles.fallback_empty_container}
                        >
                            <h3
                            className={styles.fallback_empty_title}
                            >No results found</h3>
                            <p
                            className={styles.fallback_empty_subtext}
                            >
                                Please try another search
                            </p>
                        </div>
                    </div>
                ) : <></>}
            </PerfectScrollbar>
    </ReactModal>
    <DeleteConfirmation
    isOpen={isDeleteConfirmationOpen}
    onClose={() => setIsDeleteConfirmationOpen(false)}
    onConfirm={removeMember}
    message="You are about to remove this member"
    />
    </>
  )
}

export default GroupSubscriptionMembersModal;